import {Alert, Box, CircularProgress, CssBaseline, Stack} from '@mui/material';
import * as React from 'react';
import Header from '@/components/Header';
import {useUserContext} from '@/components/Providers/UserContext';
import useFetchCourseApprovals from '@/queries/useFetchCourseApprovals';
import TableCourseApprovals from '@/components/CourseApproval/TableCourseApprovals';
import {type MutateFunctionError} from '@/types/MutateFunctionError';

const CourseApprovals = () : React.ReactElement => {
    const {user} = useUserContext();
    const courseApprovalsQuery = useFetchCourseApprovals();
    const courseApprovals = courseApprovalsQuery.data?.data;
    const courseApprovalsInfoMessage = courseApprovalsQuery.data?.message;
    const courseApprovalsErrorCode = courseApprovalsQuery.data?.errorCode;
    const courseApprovalsQueryError = courseApprovalsQuery.error as MutateFunctionError;

    return <React.Fragment>
        <CssBaseline/>
        <Header/>
        <Stack
            sx={{
                flexGrow: 1,
                backgroundColor: '#631d79',
                height: '100%',
            }}
        >
            <Stack
                direction='column'
                justifyContent='flex-start'
                sx={{
                    backgroundColor: '#fff',
                    m: 2,
                    mt: '125px',
                    flexGrow: 1,
                    overflow: 'auto',
                }}
            >
                {(courseApprovalsQuery.isLoading || user === undefined) && <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        height: '100%',
                    }}
                >
                    <CircularProgress/>
                </Stack>}

                {!courseApprovalsQuery.isLoading && <Stack
                    direction='row'
                    justifyContent='center'
                >
                    {courseApprovals && courseApprovals.approvals.length === 0 && <Alert severity='error' sx={{my: 2}}>No Course Approvals Found</Alert>}
                    {courseApprovalsQuery.isError && <Alert severity='error' sx={{my: 2}}>{courseApprovalsQueryError.message}</Alert>}
                    {courseApprovalsErrorCode !== 0 && courseApprovalsInfoMessage && <Alert severity='info' sx={{my: 2}}>{courseApprovalsInfoMessage}321</Alert>}
                </Stack>}

                {courseApprovals && courseApprovals.approvals.length > 0 && <Box sx={{width: '100%'}}>
                    <TableCourseApprovals courseApprovals={courseApprovals.approvals}/>
                </Box>}

            </Stack>
        </Stack>
    </React.Fragment>;
};

export default CourseApprovals;
